import { useEffect, useRef, useState } from "react";
import { useCountUp } from "@/hooks/useCountUp";

const stats = [
  { value: 500, suffix: "+", label: "Zufriedene Kunden" },
  { value: 2400, suffix: "+", label: "Verträge" },
  { value: 100, suffix: "%", label: "Unabhängige Beratung" },
  { value: 10, suffix: "+ Jahre", label: "Erfahrung" },
];

function StatItem({ stat, start, delay }: { stat: typeof stats[number]; start: boolean; delay: number }) {
  const value = useCountUp(stat.value, 1800, start);
  return (
    <div
      className="reveal rounded-2xl border border-white/10 bg-white/[0.04] backdrop-blur p-7 text-center hover:border-accent/40 hover:bg-white/[0.07] transition-all"
      style={{ transitionDelay: `${delay}ms` }}
    >
      <div className="font-display text-3xl md:text-4xl font-extrabold text-accent">
        {value}
        {stat.suffix}
      </div>
      <div className="mt-2 text-sm md:text-base text-white/80">{stat.label}</div>
    </div>
  );
}

export default function Stats() {
  const sectionRef = useRef<HTMLElement>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (!sectionRef.current) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setInView(true);
            io.disconnect();
          }
        });
      },
      { threshold: 0.3 }
    );
    io.observe(sectionRef.current);
    return () => io.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="py-20 md:py-28 bg-gradient-hero text-white relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-radial pointer-events-none" />
      <div className="container relative">
        <h2 className="text-center font-display text-3xl md:text-4xl lg:text-5xl font-bold text-balance reveal">
          FINABLE in Zahlen
        </h2>

        <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-5">
          {stats.map((s, i) => (
            <StatItem key={i} stat={s} start={inView} delay={i * 100} />
          ))}
        </div>
      </div>
    </section>
  );
}
